export enum GoogleLandingEditFieldName {
  STORE_LINK = 'storeLink',
  TITLE = 'title',
  ICON = 'iconUrl',
  PIXEL_ID = 'pixelId',
  IMAGE_PREVIEWS = 'imagePreviews',
  DESCRIPTION = 'description',
}
